import grapesjs from "grapesjs";
import { useEffect } from "react";
import { useFooterEditor } from "../../../context/GrapeJsFooterContext";
import { tw } from "@careinfo/tailwind";
import { deviceManager } from "./deviceManage";
import footerPlugins from "../Plugins/Footer";
import useEditor from "../../../hooks/useEditor";
import APIS from "../../../constant/Endpoint";
import { accessToken } from "../../../helpers/sessionKey";
import { API_ROOT } from "../../../helpers/AxiosInstance";

const FooterEditor = (props: any) => {
  const { editorFooterRef, handleDisable } = props;
  const { setEditor: setFooterEditor } = useFooterEditor();
  const { handleMediaUpload } = useEditor();
  const rootColors = {
    "--primary": "#ef4444",
    "--secondary": "#fea9a9",
  };

  const injectRootVariablesIntoCanvas = (editorInstance) => {
    const canvas = editorInstance.Canvas;
    const iframe = canvas.getFrameEl();

    if (iframe) {
      const iframeDocument =
        iframe.contentDocument || iframe.contentWindow.document;
      const style = iframeDocument.createElement("style");
      style.textContent = `
        :root {
          --primary: ${rootColors["--primary"]};
          --secondary: ${rootColors["--secondary"]};
        }
      `;

      // Append the <style> element to the iframe's <head>
      iframeDocument.head.appendChild(style);
    }
  };
  useEffect(() => {
    if (!editorFooterRef.current) {
      const editorInstance = grapesjs.init({
        container: "#footer-container",
        fromElement: true,
        plugins: [...footerPlugins],
        panels: { defaults: [] },
        height: "300px",
        width: "auto",
        deviceManager: deviceManager,
        canvas: {
          scripts: [
            "https://careinfo-solutions.s3.ap-south-1.amazonaws.com/tailwind/tailwind.min.js",
            "https://cdn.jsdelivr.net/npm/toastify-js",
          ],
        },
        assetManager: {
          assets: [],
          autoAdd: true,
          dropzone: true,
          openAssetsOnDrop: true,
          showUrlInput: true,
          uploadFile: function (ev: any) {
            const files = ev.dataTransfer
              ? ev.dataTransfer.files
              : ev.target.files;
            if (editorFooterRef.current) {
              handleMediaUpload(files, editorInstance);
            }
          },
        },
        storageManager: {
          type: "remote",
          autosave: false,
          autoload: true,
          stepsBeforeSave: 1,
          options: {
            remote: {
              headers: {
                "Content-Type": "application/json",
                Authorization: `JWT ${accessToken()}`,
              },
              urlLoad: `${API_ROOT}${APIS.FOOTER}`,
            },
          },
        },
        blockManager: {
          appendTo: "#footer-blocks",
        },
        traitManager: {
          appendTo: "#footer-trait",
        },
        styleManager: {
          appendTo: "#footer-style",
        },
        selectorManager: {
          appendTo: "#footer-selector",
        },
      });
      editorInstance.on("load", () => {
        injectRootVariablesIntoCanvas(editorInstance);
      });
      setFooterEditor(editorInstance);
      editorFooterRef.current = editorInstance;
    }
    return () => {
      if (editorFooterRef.current) {
        editorFooterRef.current.destroy();
        editorFooterRef.current = null;
      }
    };
  }, []);

  return (
    <>
      <style>{`
        :root {
          --primary:rgba(250, 7, 7, 0);
          --secondary: rgba(0, 0, 0, 0.1);
        }
      `}</style>
      <footer
        id="footer-container"
        className={tw`my-1 shadow`}
        onMouseEnter={() => handleDisable("footer")}
      ></footer>
    </>
  );
};

export default FooterEditor;
